import React, { useCallback } from 'react';
import { namesAndIds } from '../../../../../../../types/shared/PrequalificationDataEntry';
import useValidOnFocus from '../../hooks/useValidOnFocus';
import { useHomeAddress } from '../../../../../providers/HomeAddressProvider';
import { useHomeAddressError } from '../../../../../providers/HomeAddressErrorProvider';
import SlideDown from '../../../../../../SlideDown/SlideDown';
import { transformHTMLParserLinks } from '../../../../../../../utils/rewriteLink/rewriteLink';
import { usePageProperties } from '../../../../../providers/PagePropertiesProvider';
import { usePersonalInformationError } from '../../../../../providers/PersonalInformationErrorProvider';
import { usePersonalInformation } from '../../../../../providers/PersonalInformationProvider';
import { isDateValid } from '../../../../../../../utils/acquisition-utils';
import StateField from '../../../../../../FieldContainers/AddressFields/StateField/StateField';
import { generateFieldErrorMessage } from '../../../../../../../utils/error-message';
import { TStateDropdownInputProps } from '../StateDropdown/StateDropdown';

export default function HomeAddressStateDropdown({ addressValidationCheck, onKeyDown, isPrefill, disabled = false }:TStateDropdownInputProps) {
    const { wiResidentDisclaimerText } = usePageProperties();
    const {
        personalInformation: { dob },
    } = usePersonalInformation();
    const dispatchDOBError = usePersonalInformationError();
    const {
        homeAddress: { HomeState },
        setSingleValue,
    } = useHomeAddress();
    const {
        homeAddressError: {
            HomeState: { required, isInError, isValidValue },
        },
        dispatch,
    } = useHomeAddressError();

    const setValid = useCallback((isValid: boolean) => {
        dispatch({
            type: 'setValid',
            target: 'HomeState',
            payload: isValid,
        });
    }, []);

    const setDOBValid = useCallback((isValid: boolean) => {
        dispatchDOBError.dispatch({
            type: 'setValid',
            target: 'dob',
            payload: isValid,
        });
    }, []);

    const { setValidOnFocus } = useValidOnFocus(isInError, setValid);

    const handleBlur = () => {
        addressValidationCheck();
        if (dob.length === 10) {
            const dateValid = isDateValid(dob, HomeState);
            setDOBValid(dateValid);
        }
    };

    const handleState = (val: string) => {
        setValidOnFocus();
        setSingleValue('HomeState')(val);
    };

    return (
        <div>
            <div className='PqDataEntryForm__inputRow' id='homeState-field-container'>
                <StateField
                    {...namesAndIds.HomeState}
                    value={HomeState}
                    setValueCallback={(val) => handleState(val)}
                    placeholder='Select a State...'
                    alternate
                    mixed
                    required={required}
                    valid={[isValidValue, setValid]}
                    error={isInError}
                    errorText={generateFieldErrorMessage('Home Address State', 'missingValue')}
                    requiredMessage={generateFieldErrorMessage('Home Address State', 'missingValue')}
                    invalidErrorMessage={generateFieldErrorMessage('Home Address State', 'missingValue')}
                    onFocusCallback={setValidOnFocus}
                    onBlurCallback={handleBlur}
                    onKeyDownCallback={onKeyDown}
                    disabled={disabled}
                    useOutsideValidation={isValidValue}
                    isPrefill={isPrefill}
                    useSuccessIcon
                    showSuccessIcon={disabled || undefined}
                />
            </div>
            <SlideDown
                className='PqDataEntryForm__main--disclaimer'
                open={HomeState === 'WI'}
            >
                {transformHTMLParserLinks(wiResidentDisclaimerText)}
            </SlideDown>
        </div>
    );
}
